// Vue 3: vue-i18n v9 uses createI18n
import { createI18n } from 'vue-i18n'
import en from './locales/en.json' with { type: 'json' }
import ptBR from './locales/pt_BR.json' with { type: 'json' }

const messages = {
  en,
  pt_BR: ptBR
}

export const IDIOMAS = [
  { valor: 'pt_BR', rotulo: 'Português', curto: 'PT' },
  { valor: 'en', rotulo: 'English', curto: 'EN' }
]

const CHAVE_ARMAZENADA = 'footie_locale'

// A escolha de idioma precisa sobreviver ao recarregamento. Antes o seletor só
// atribuía `$i18n.locale` em memória: trocava a tela e voltava ao padrão no F5,
// o que fazia o recurso parecer quebrado.
function localeInicial() {
  try {
    const salvo = localStorage.getItem(CHAVE_ARMAZENADA)
    if (salvo && messages[salvo]) return salvo
  } catch (e) {
    // localStorage pode estar bloqueado (navegação privada, iframe). Não é
    // motivo para derrubar o boot do app.
  }
  return process.env.VUE_APP_I18N_LOCALE || 'pt_BR'
}

export function salvarLocale(locale) {
  try {
    localStorage.setItem(CHAVE_ARMAZENADA, locale)
  } catch (e) {
    // ver acima
  }
}

// `silentTranslationWarn` e `silentFallbackWarn` estavam LIGADOS, e eram
// exatamente os dois avisos que diriam "esta chave não existe" e "caiu no
// idioma reserva".
//
// Com eles ligados o app escondia as próprias lacunas: a tela mostrava o texto
// em português e nada reclamava — foi assim que 60 dos 64 componentes ficaram
// sem uma única chamada de tradução sem ninguém perceber.
//
// Agora ficam ligados só em produção, onde o aviso não tem para quem falar.
// Em desenvolvimento o console reclama, e é essa reclamação que mede o
// progresso da migração.
const emProducao = process.env.NODE_ENV === 'production'

export default createI18n({
  legacy: true, // Options API, para os componentes existentes
  locale: localeInicial(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'pt_BR',
  messages,
  silentTranslationWarn: emProducao,
  silentFallbackWarn: emProducao
})
